import { notifySessionExpired, requireMfaStepUp } from "./mfaStepUp";

type ErrorBody = { detail?: unknown };

function errorCode(body: ErrorBody): string | null {
  const detail = body.detail;
  if (!detail || typeof detail !== "object" || !("code" in detail)) return null;
  return typeof detail.code === "string" ? detail.code : null;
}

function requiresMfaStepUp(status: number, body: ErrorBody): boolean {
  const code = errorCode(body);
  return (
    (status === 401 && code === "AUTH_MFA_REQUIRED")
    || (status === 403 && code === "MFA_STEP_UP_REQUIRED")
    || (status === 403 && body.detail === "recent MFA authentication is required")
  );
}

export async function sessionAwareFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
  allowStepUpRetry = true,
): Promise<Response> {
  const response = await fetch(input, init);
  if (response.ok) return response;

  const body = await response.clone().json().catch(() => ({})) as ErrorBody;
  const code = errorCode(body);

  if (requiresMfaStepUp(response.status, body) && allowStepUpRetry) {
    await requireMfaStepUp();
    return sessionAwareFetch(input, init, false);
  }

  if (response.status === 401 && code !== "AUTH_MFA_REQUIRED") {
    notifySessionExpired();
  }
  return response;
}
